import { takeEvery, select, fork } from 'redux-saga/effects'
import URI from 'urijs'

import { search } from 'parking-react-common'

import * as routing from './routing'

export const {
    perform, reducer,
    getQuery, getResults, isSearching, isPerformed,
    REQUESTED, PERFORMED,
    LOCAL_SKIPPED, LOCAL_STARTED, LOCAL_SUCCEEDED, LOCAL_FAILED,
    SERVER_SKIPPED, SERVER_STARTED, SERVER_SUCCEEDED, SERVER_FAILED
} = search


//
//  SAGA

export function* saga() {
    yield fork(search.saga)
    yield takeEvery(PERFORMED, updateAddressWithSearchParams)
}

function* updateAddressWithSearchParams({ payload }) {
    const { url, options } = payload

    if (!options.updateAddressBar) {
        return
    }

    const searchQuery = yield select(getQuery(url))
    const currentRoute = yield select(routing.getCurrentRoute)

    const newUrl = new URI(currentRoute.url)
    searchQuery
        ? newUrl.addSearch('search', searchQuery)
        : newUrl.removeSearch('search')

    routing.replace(newUrl.toString()) // eslint-disable-line lodash/prefer-lodash-method
}
